import { AfterContentInit, Component, ContentChild, Input, TemplateRef, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, Optional, SkipSelf } from '@angular/core';
import { NgControl } from '@angular/forms';
import { takeUntil, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PhxInputComponent, PhxInputStyle } from './phx-input.component';
import { PhxContextService, PHOENIX_CONTEXTS } from '../../services/phx-context-service';

@Component({
  selector: 'phx-input-group',
  exportAs: 'phxInputGroup',
  templateUrl: './phx-input-group.component.html',
  styleUrls: ['./phx-input-group.component.scss'],
  host: {
    class: 'phx-input-group',
    '[class.phx-has-add-on-after]': '!!phxAddOnAfter',
    '[class.phx-has-prefix]': '!!phxPrefix',
    '[class.phx-has-suffix]': '!!phxSuffix',
    '[class.phx-filter]': 'phxStyleType === PHOENIX_CONTEXTS.FILTER',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxInputGroup implements AfterContentInit {
  @Input() public phxSuffix?: TemplateRef<any>;
  @Input() public phxPrefix?: TemplateRef<any>;
  @Input() public phxAddOnBefore?: TemplateRef<any>;
  @Input() public phxAddOnAfter?: TemplateRef<any>;
  @Input() public phxIsInvalid?: boolean;
  @ContentChild(PhxInputComponent) public input!: PhxInputComponent;
  @ContentChild(NgControl) public formControl!: NgControl;

  public disabled: boolean = false;
  public style: PhxInputStyle = 'default';
  public phxHasValue: boolean = false;
  public readonly PHOENIX_CONTEXTS = PHOENIX_CONTEXTS;
  public phxStyleType: PHOENIX_CONTEXTS;
  public phxFormError?: boolean = false;
  public hasBeenTouched?: boolean = false;

  private _destroy$ = new Subject<void>();

  constructor (
    private cdr: ChangeDetectorRef,
    @Optional() @SkipSelf() contextService: PhxContextService) {
      this.phxStyleType = contextService?.getType();
  }

  public ngAfterContentInit(){
    this.input.forceBorderlessStyle();
    this.input.disabled$.subscribe((value) => {
      this.disabled = value;
      this.cdr.markForCheck();
    });
    this.input.style$.subscribe((value) => {
      this.style = value;
      this.cdr.markForCheck();
    });
    this.formControl?.valueChanges
      .pipe(takeUntil(this._destroy$))
      .pipe(distinctUntilChanged())
      .subscribe(value => {
        this.phxHasValue = value?.length > 0;
        this.cdr.markForCheck();
    });

    var elemToObserve = this.input.elRef.nativeElement;
    var thisComponent = this;
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if(mutation.attributeName == "class"){
            //@ts-ignore
            thisComponent.hasBeenTouched = mutation.target.classList.contains('ng-touched');
            //@ts-ignore
            thisComponent.phxFormError = mutation.target.classList.contains('ng-invalid');
            thisComponent.cdr.markForCheck();
          }
      });
    });
      observer.observe(elemToObserve, {attributes: true});
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public focusInput(): void {
    if (this.disabled) return;
    this.input.focus();
  }
}
